import { IonCheckbox, IonLabel } from '@ionic/react'
import React from 'react'
import { CommonInputProps } from './BaseInput'

interface CheckboxInputProps extends CommonInputProps {
	onChange?: (value: string) => void
	isChecked: boolean
	label: string
}
const CheckboxInput: React.FC<CheckboxInputProps> = ({
	onChange,
	label,
	readonly,
	isChecked,
}: CheckboxInputProps): JSX.Element => {
	const onClick = (e: React.MouseEvent<HTMLIonCheckboxElement, MouseEvent>) => {
		if (!onChange) return
		e.preventDefault()
		onChange(e.currentTarget.value)
	}

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
			}}
		>
			<IonCheckbox
				className='dark:[--border-color:#3cb49f] dark:[--border-color-checked:#3cb49f] dark:[--checkbox-background-checked:#3cb49f] dark:[--checkbox-background:#144448] [--border-color:#52ae32] [--border-color-checked:#52ae32] [--checkbox-background-checked:#52ae32] [--checkbox-background:#cae3cc]'
				checked={isChecked}
				onClick={onClick}
				disabled={readonly}
			/>
			<IonLabel style={{ width: '100%' }} onClick={onClick}>
				{label}
			</IonLabel>
		</div>
	)
}

export default CheckboxInput
